<template>
  <span class="message">{{ message }}</span>
</template>

<script>
export default {
  name: 'MapMessage',

  props: {
    question: {
      type: Object,
      required: true
    },
    answer: {
      type: Object,
      required: true
    }
  },

  computed: {
    message () {
      let result
      if (!Array.isArray(this.answer.result)) {
        result = [{ value: this.answer.result.value }]
      } else {
        result = this.answer.result
      }

      return this.question.message.config.find((message) => {
        return result.some(({ value }) => message.results.includes(value))
      }).value
    }
  }
}
</script>

<style lang="scss" scoped>
  .message {
    @media (max-width: $screen-md) {
      font-size: 15px;
    }
  }
</style>
